import {createReducer} from '@reduxjs/toolkit';
import {
    deleteReleaseNoteFailure,
    getReleaseNotesFailure,
    saveReleaseNoteFailure,
} from 'src/openapi/admin/apis/ReleaseNotesControllerApi';

import {clearError, setReleaseNotes} from './actions';

import type {ChangesInfo} from 'src/openapi/admin/models/ChangesInfo';
import type {Error} from 'src/openapi/admin/models/Error';
import type {ReleaseNote} from 'src/openapi/admin/models/ReleaseNote';

export type State = {
    data: {
        releaseNotes: Array<ReleaseNote> | undefined,
        changesInfo: ChangesInfo | undefined,
    },
    error: Error | null,
};

const defaultState: State = {
    data: {
        releaseNotes: undefined,
        changesInfo: undefined,
    },
    error: null,
};

export const releaseNotes = createReducer(defaultState, builder => builder
    .addCase(setReleaseNotes, (state, action) => {
        state.data = {
            releaseNotes: action.payload.releaseNotes,
            changesInfo: action.payload.changesInfo,
        };
    })
    .addCase(getReleaseNotesFailure, (state, action) => {
        state.error = action.payload.data;
    })
    .addCase(deleteReleaseNoteFailure, (state, action) => {
        state.error = action.payload.data;
    })
    .addCase(saveReleaseNoteFailure, (state, action) => {
        state.error = action.payload.data;
    })
    .addCase(clearError, state => {
        state.error = null;
    }),
);
